import { MagnifyingGlass, X } from 'phosphor-react'
import PropTypes from 'prop-types'
import { Component } from 'react'
import { connect } from 'react-redux'
import { getArticulos, getArticulosByFamily, setBusqueda } from '../../actions/articulos'
import { limpiarFiltros, limpiarFiltrosTexto } from '../../actions/filtros'
import { withRouter } from '../../helpers/funciones'
import { creaURLArticulo } from '../../helpers/urls/articulos'
import i18n from '../../lang/idiomas'
import AnalyticsEdisa from '../common/AnalyticsEdisa'

export class Buscador extends Component {
  state = {
    valor: '',
  }

  static propTypes = {
    isLoadingArticulos: PropTypes.bool.isRequired,
    articulos_pagina: PropTypes.number.isRequired,
    articulos_orden: PropTypes.string.isRequired,
    filtros_aplicados: PropTypes.array.isRequired,
    auth: PropTypes.object,
    getArticulos: PropTypes.func.isRequired,
    getArticulosByFamily: PropTypes.func.isRequired,
    header: PropTypes.bool,
    mobile: PropTypes.bool,
    isOpen: PropTypes.bool,
    onToggle: PropTypes.func,
  }

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  onSubmit = e => {
    e.preventDefault()
    const { valor } = this.state

    let valorBusqueda = valor.trim()
    if (/^\d{1,3}$/.test(valorBusqueda)) {
      valorBusqueda = valorBusqueda.padStart(4, '0')
    }

    let analytics = new AnalyticsEdisa()
    analytics.registraEvento({
      modulo: 'Articulos',
      tipo: 'Search',
      valor: valorBusqueda,
    })

    this.props.setBusqueda(valorBusqueda)

    this.props.limpiarFiltros()

    this.props.limpiarFiltrosTexto()

    this.props
      .getArticulos(
        valorBusqueda,
        this.props.articulos_pagina,
        this.props.articulos_orden,
        this.props.pedido.domicilio_envio ? this.props.pedido.domicilio_envio : '',
      )
      .then(data => {
        // Requisito Casals: si la búsqueda devuelve un único artículo,
        // redirigimos directamente a su ficha en vez de mostrar el listado.
        if (data?.count === 1 && data?.results?.length === 1) {
          const articulo = data.results[0]
          this.props.router.navigate(
            creaURLArticulo(articulo.codigo_articulo, articulo.descrip_comercial),
          )
        }
      })

    this.setState({
      valor: '',
    })

    if (this.props.router && this.props.router.location.pathname !== '/articulos') {
      this.props.router.navigate('/articulos')
    }
  }

  render() {
    const { valor } = this.state
    if (this.props.isLoadingArticulos) {
      document.body.style.cursor = 'wait'
    } else {
      document.body.style.cursor = 'default'
    }

    const form = (
      <form
        onSubmit={this.onSubmit}
        className={
          this.props.mobile && this.props.isOpen
            ? 'form-default'
            : `form-inline form-default justify-content-end pr-3${this.props.header ? ' d-none d-md-flex' : ''}`
        }
        style={
          this.props.mobile && this.props.isOpen ? { display: 'flex', flex: 1, minWidth: 0 } : {}
        }>
        <div className={`input-group${this.props.mobile && this.props.isOpen ? ' w-100' : ''}`}>
          <input
            className='form-control'
            type='text'
            name='valor'
            placeholder={i18n.t('general.buscphol')} //'Referencia CASALS, Referencia OEM, Descripción, etc...' // TODO: Cambiar a clave traducción
            onChange={this.onChange}
            value={valor}
          />
          <div className='input-group-append'>
            <button
              type='submit'
              className='btn btn-primary'
              disabled={this.props.isLoadingArticulos}>
              <MagnifyingGlass
                size={20}
                weight='bold'
              />
              {!this.props.mobile && i18n.t('general.buscar')}
            </button>
          </div>
        </div>
        {this.props.mostrar_avanzado === 'S' ? (
          <div className='enlace-busqueda-avanzada'>
            <button
              type='button'
              onClick={e => {
                e.preventDefault()
                this.props.setBusqueda('')
                this.props.cambiarBuscador()
              }}
              className='btn btn-link enlace-busqueda-avanzada-btn'>
              {i18n.t('general.busavtit')}
            </button>
          </div>
        ) : (
          ''
        )}
      </form>
    )

    if (this.props.mobile) {
      const { isOpen, onToggle } = this.props
      return (
        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          {!isOpen ? (
            <button
              onClick={() => onToggle(true)}
              type='button'
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '0',
                display: 'flex',
                alignItems: 'center',
              }}>
              <MagnifyingGlass
                size={22}
                weight='bold'
              />
            </button>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center', width: '100%', gap: '8px' }}>
              {form}
              <button
                onClick={() => onToggle(false)}
                type='button'
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '0',
                  display: 'flex',
                  alignItems: 'center',
                  flexShrink: 0,
                }}>
                <X
                  size={22}
                  weight='bold'
                />
              </button>
            </div>
          )}
        </div>
      )
    }

    if (this.props.header) {
      return form
    }

    return (
      <div className='container'>
        <div className='row buscador'>
          <div className='col-md-6'>{form}</div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  isLoadingArticulos: state.listadoArticulos.articulos.isLoading,
  articulos_pagina: state.listadoArticulos.articulos_pagina,
  articulos_orden: state.listadoArticulos.articulos_orden,
  filtros_aplicados: state.articulos.filtros_aplicados,
  portal: state.portal.portal,
  cookies: state.portal.cookies,
  pedido: state.pedidos.pedido,
})

export default withRouter(
  connect(mapStateToProps, {
    getArticulos,
    setBusqueda,
    getArticulosByFamily,
    limpiarFiltros,
    limpiarFiltrosTexto,
  })(Buscador),
)
